export default "__VITE_ASSET__j3UDzcUX__"